import { render } from "./ClientNoteTextArea.vue?vue&type=template&id=84e5d458&scoped=true"
import script from "./ClientNoteTextArea.vue?vue&type=script&lang=ts"
export * from "./ClientNoteTextArea.vue?vue&type=script&lang=ts"

import "./ClientNoteTextArea.vue?vue&type=style&index=0&id=84e5d458&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-84e5d458"

export default script